import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * A barely-there sparkline showing daily writing rhythm over the last 30 days.
 * Each day = a circle. Radius and opacity scale with count. No labels, no shame.
 */
export default function Constellation({ refreshKey }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/stats/daily", { params: { days: 30 } })
      .then((res) => { if (!cancelled) setData(res.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [refreshKey]);

  if (!data.length) return null;

  const w = 100;
  const h = 18;
  const max = Math.max(1, ...data.map((d) => d.count));
  const step = w / (data.length - 1 || 1);

  return (
    <div className="select-none" data-testid="constellation">
      <svg
        viewBox={`0 0 ${w} ${h}`}
        className="w-full h-5 text-muted-foreground"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        {data.map((d, i) => {
          const x = i * step;
          const y = h / 2;
          const intensity = d.count / max;
          const r = d.count === 0 ? 0.45 : 0.7 + intensity * 1.4;
          const opacity = d.count === 0 ? 0.18 : 0.45 + intensity * 0.5;
          return (
            <circle
              key={d.date}
              cx={x}
              cy={y}
              r={r}
              fill="currentColor"
              opacity={opacity}
            >
              <title>{`${d.date}: ${d.count}`}</title>
            </circle>
          );
        })}
      </svg>
    </div>
  );
}
